<template>
  <div class="case-right-container">
    <div id="blurr"></div>
    <div id="accc"></div>
    <div class="center-right">
      <!-- <div class="none" id="popular">
        <div class="button">
          <div class="a" onclick="toggle()"></div>
          <img :src="this.imgPath" alt="" />
          <h1>{{ this.title }}</h1>
          <div class="bm">
            <span
              >般极活性济众己率况八史次等较音与县断青话号选子次成流加约元派产王日线消精军知比口门对每眼形过政保经同改金特极近那性京段元物土机亲气细调治。次设接广四物飞还心时严业整面研东量意直织省社立日号当把直传度决次取但提深非。究心意包四据张证总别斯热非习易土没业识反气没各书明是级合史着包小十重一思根响较区场员及相长处百交学太下四许。油约更道队对织般带参指情林被公则权铁今石片称素六四非快满之养原华空指然个器理干花县科共极铁走五党更放布段明大容次去了农那导问。</span
            >
          </div>
        </div>
      </div> -->
      <el-dialog
        customClass="customWidth"
        :visible.sync="dialogVisible"
        :show-close="false"
        :lock-scroll="false"
        :center="true"
        title=""
      >
        <div slot="title" class="dialog-title">
          <img :src="this.imgPath || defaultImg" />
        </div>
        <img
          class="dialog-close"
          src="@/assets/img/case/icon_close@2x.png"
          @click="toggle()"
        />
        <div slot="" class="dialog-content">
          <h5>{{ this.title }}</h5>
          <p>
            {{ content }}
          </p>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>

      <ul class="case-item">
        <li v-for="(person, index) in watermarkedImageList" :key="index">
          <div class="img">
            <img
              :src="person.imgPath || defaultImg"
              alt=""
              @error="handleImageError(arr, index)"
            />
          </div>
          <div class="text">
            <p>{{ person.title }}</p>
            <div @click="toggle(index)">
              <span>查看更多</span
              ><img src="../../assets/img/download2/icon_more.png" alt="" />
            </div>
          </div>
        </li>
      </ul>
      <div
        v-if="!isLoading"
        class="loadingBox"
        v-loading="!isLoading"
        element-loading-text="正在加载中"
      ></div>
      <div v-show="total > 12 && isLoading" class="pagination">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="total"
          :current-change="pageNum"
          @current-change="handleCurrentChange"
          :page-size="12"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { addWatermarkToData } from "@/utils/watermark";

export default {
  name: "project6",
  data() {
    return {
      subCategory: "1",
      status: 1,
      type: 2,
      category: "建筑智能化-文博系统",
      arr: [],
      imgPath: "",
      title: "",
      content: "",
      dialogVisible: false,
      total: 0,
      pageNum: 1,
      isLoading: false,
      pageSize: 12,
      originalImages: [], // 存储从接口获取的原始图片数据
      watermarkedImages: [], // 存储带水印的图片地址
      watermarkedImageList: [] //存储所有带水印的图片地址
    };
  },
  mounted() {
    this.selectBySub();
    window.toggle = this.toggle;
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },
    // selectBySub() {
    //   this.request
    //     .get(`/${this.status}/${this.type}`, {
    //       params: {
    //         pageSize: this.pageSize,
    //         pageNum: this.pageNum,
    //         category: this.category,
    //         total: this.total,
    //         sort: 1
    //       }
    //     })
    //     .then(res => {
    //       console.log(res.data);
    //       this.arr = res.data.data;
    //       this.total = res.data.total;
    //     });
    // },
    async selectBySub() {
      try {
        const res = await this.request.get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            category: this.category,
            total: this.total,
            sort: 1
          }
        });
        console.log(res.data);
        this.arr = res.data.data;
        this.total = res.data.total;

        // 调用函数并传入数据数组
        this.originalImages = res.data.data;
        await addWatermarkToData(res.data.data, this);
      } catch (error) {
        console.error("请求数据出错", error);
      }
    },

    // loadMoreData() {
    //   if (this.isLoading) {
    //     return;
    //   }
    //   this.isLoading = true;
    //   this.selectBySub();
    // },
    // selectBySub() {
    //   this.request
    //     .get(`/${this.status}/${this.type}`, {
    //       // 问题：   如何判断输入了那些条件只传查询条件 空的不传   ??????
    //       params: {
    //         pageSize: this.pageSize,
    //         pageNum: this.pageNum,
    //         category: this.category,
    //         total: this.total
    //       }
    //     })
    //     .then(res => {
    //       const newData = res.data.data;
    //       // 将新数据添加到dataList中
    //       this.arr.push(...newData);
    //       this.pageNum++;
    //       this.isLoading = false;
    //       // console.log(res.data);
    //       // this.arr = res.data.data;
    //       // this.total = res.data.total;
    //     });
    // },
    toggle(index) {
      if (index >= 0) {
        // this.imgPath = this.arr[index].imgPath;
        this.imgPath = this.watermarkedImageList[index].imgPath;
        this.title = this.arr[index].title;
        // this.content = this.getSimpleText(this.arr[index].content);
      }

      // 新的弹出窗口打开关闭方法
      if (!this.dialogVisible) {
        this.dialogVisible = true;
        document.body.style.paddingRight = "0px";
      } else {
        this.dialogVisible = false;
      }

      //   var sy = document.getElementById("accc").style.display;
      //   if (sy === "inline") {
      //     document.getElementById("accc").style.display = "none";
      //   } else {
      //     document.getElementById("accc").style.display = "inline";
      //   }
      //   console.log(document.getElementById("accc").style.display + "###");
      //   var blur = document.getElementById("blurr");
      //   blur.classList.toggle("active");
      //   var popular = document.getElementById("popular");
      //   popular.classList.toggle("active");
      //   var acc = document.getElementById("accc");
      //   acc.classList.toggle("active");
    },
    handleCurrentChange(pageNum) {
      this.isLoading = false;
      (this.pageNum = pageNum), this.selectBySub();
      this.scrollToPosition();
      this.$nextTick(window.scrollBy(0, 120));
    },
    scrollToPosition(position) {
      // 在点击选项卡时设置滚动位置为之前的滚动位置
      window.scrollTo({
        top: 300
      });
    },

    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”"
      };
      return html
        .replace(re1, "")
        .replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi, function(
          all,
          t
        ) {
          return arrEntities[t];
        });
    }
  }
};
</script>
<style>
.el-dialog__wrapper {
  display: flex;
  padding: 30px 0;
}
.el-dialog__wrapper .el-dialog {
  margin: auto !important;
}
</style>
<style scoped>
@import "../../assets/css/casePresentation.css";

.customWidth {
  width: 50%;
  min-width: 800px;
}
.pagination {
  /* position: absolute;
  bottom: 125px;
  left: 50%;
  transform: translateX(-50%); */
  text-align: center;
  padding-bottom: 20px;
}
.dialog-title img {
  padding: 20px 20px 0 20px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dialog-close {
  position: absolute;
  top: -16px;
  right: -56px;
  width: 32px;
  height: 32px;
}
.dialog-content {
  padding: 0 13px;
  font-size: 18px;
  color: rgba(29, 30, 32, 1);
  letter-spacing: 1px;
  line-height: 25px;
}
.dialog-content p {
  margin-top: 15px;
  font-size: 14px;
  color: rgba(29, 29, 29, 0.62);
  line-height: 28px;
}

.center-right {
  /* position: relative; */
  /* float: left;
  flex: 1;
  width: 1092px;
  height: 999.9936px;
  margin-left: 30px; */
}
/* .center-right ul {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(4, 25%);
  justify-items: end;
} */
.center-right ul li {
  margin-bottom: 32px;
  width: 247px;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
  transition: transform 0.3s;
}
.center-right ul li:nth-child(4n) {
  margin-right: 0;
}
.center-right ul li .img {
  background-size: 100% 100%;
  height: 224px;
}
.center-right ul li .img img {
  width: 100%;
  height: 100%;
}
.center-right ul li .text {
  position: relative;
  height: 163px;
  background: rgb(251 251 251);
  box-shadow: 0px 1px 8px 0px rgba(206, 206, 206, 0.5);
}
.center-right ul li .text p {
  display: block;
  position: absolute;
  width: 206px;
  height: 59px;
  top: 16px;
  left: 16px;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.58);
  line-height: 29px;
}
.center-right ul li .text div {
  cursor: pointer;
  position: absolute;
  top: 88px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 163px;
  left: 16px;
  height: 42px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgb(206 206 206 / 50%);
  border-radius: 3.9936px;
  border: 0.9984px solid #140047;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #140047;
}
.center-right ul li .text div span {
  left: 26px;
  position: absolute;
  width: 59px;
  height: 18px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  line-height: 18px;
  text-shadow: 0px 1px 8px rgba(206, 206, 206, 0.5);
}
.center-right ul li .text div img {
  position: absolute;
  left: 109px;
  width: 41px;
  height: 34px;
  border: 1px dashed #000;
}
.center-right ul li:hover {
  transform: translate(0, -10.0032px);
}

#accc {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
  display: none;
}
#blurr.active {
  pointer-events: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
body {
  position: relative;
}
.none {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 975px;
  height: 836px;
  background-color: bisque;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
.none .button {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 0 40px;
}
.none .button .bm {
  width: 910px;
  height: 91px;
}
.none .button .bm span {
  display: block;
  width: 1820px;
  height: 182px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1d1d;
  opacity: 0.44;
  overflow: hidden;
  transform-origin: left;
  transform-origin: 0% 0%;
  -webkit-transform: scale(0.5);
  letter-spacing: 2px;
  line-height: 46px;
}
.none .a {
  position: absolute;
  right: -56px;
  top: -16px;
  display: block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: url(../../assets/img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none img {
  margin: 33px 0;
  width: 910px;
  height: 618px;
}
.none h1 {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 400;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 0.9984px;
}
.none p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 28px;
  letter-spacing: 0.9984px;
  padding-bottom: 40px;
}
#popular.active {
  top: 366.0096px;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}
.pagination >>> .el-pager .active {
  background-color: #140047 !important;
  color: #fff;
}
.pagination >>> .number,
.pagination >>> .btn-prev,
.pagination >>> .btn-next {
  background-color: #fff !important;
  border-radius: 6px !important;
  border: 1px solid #dddddd;
}
.pagination >>> .el-icon-more {
  background-color: #fff !important;
}
.news-right .pagination {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/case/project6.vue